export default {
  accessToken: process.env.VUE_APP_MAPBOX_KEY,
  style: process.env.VUE_APP_MAPBOX_STYLE_URL,
  initialZoom: +process.env.VUE_APP_MAPBOX_INITIAL_ZOOM || 14,
  defaultMapRouteProfile: 'walking', // Available profiles: https://docs.mapbox.com/api/navigation/map-matching/#retrieve-a-match
  defaultMapRouteLineWidth: 6,
  center: {
    lng: +process.env.VUE_APP_MAPBOX_INITIAL_CENTER_LNG || 0,
    lat: +process.env.VUE_APP_MAPBOX_INITIAL_CENTER_LAT || 0
  }
}
